import { render, staticRenderFns } from "./airMarkup.vue?vue&type=template&id=ea1283ce&scoped=true&"
import script from "./airMarkup.vue?vue&type=script&lang=js&"
export * from "./airMarkup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1283ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea1283ce')) {
      api.createRecord('ea1283ce', component.options)
    } else {
      api.reload('ea1283ce', component.options)
    }
    module.hot.accept("./airMarkup.vue?vue&type=template&id=ea1283ce&scoped=true&", function () {
      api.rerender('ea1283ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceAir/components/airMarkup.vue"
export default component.exports